// extracted by mini-css-extract-plugin
export default {"lds_ring":"Loader_lds_ring__NSb3R"};